import { isProductionEnvironment } from 'shared/utils/is-environment';
import { registerSW } from 'virtual:pwa-register';

export const initServiceWorker = () => {
  if (typeof window === 'undefined') {
    return;
  }

  // A reload mid-auth spends the URL's single-use credential (oobCode / claim token) for nothing.
  const noAutoReloadRoutes = [
    '/tasks/create',
    '/reset-password',
    '/complete-signup',
  ];
  const isSensitiveRoute = noAutoReloadRoutes.some((route) =>
    window.location.pathname.startsWith(route),
  );

  // ---------------------------------------------------------------------------
  // SCENARIO A: Sensitive Route (task creation, oobCode auth flows)
  // Requirements:
  // 1. Register SW (for offline cache) but with param to DISABLE Firebase
  // 2. Do NOT trigger auto-reloads
  // ---------------------------------------------------------------------------
  if (isSensitiveRoute) {
    if ('serviceWorker' in navigator) {
      // We use native registration here to append the query parameter
      // This ensures Firebase is NOT initialized in the worker for this page.
      navigator.serviceWorker
        .register('/service-worker.js?exclude_firebase=true')
        .then((registration) => {
          if (!isProductionEnvironment) {
            // eslint-disable-next-line no-console -- non-prod log
            console.log(
              'Service Worker registered in lightweight mode (No Firebase, No Auto-reload).',
            );
          }

          // Optional: If there is a waiting worker, we can activate it to ensure
          // the user has the latest assets, but we deliberately do NOT reload the page.
          if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          }
          return;
        })
        .catch((error) => {
          if (!isProductionEnvironment) {
            // eslint-disable-next-line no-console -- non-prod log
            console.error('Service Worker registration failed:', error);
          }
        });
    }
    // EXIT EARLY: We are done. We do not want to attach the reload listeners below.
    return;
  }

  // if allowed, setup Listeners & Register
  if ('serviceWorker' in navigator && !!navigator.serviceWorker) {
    // triggers a reload when the Service Worker updates
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // Prevent infinite loop: only reload if we were already controlled
      if (!navigator.serviceWorker.controller) {
        return;
      }

      if (!isProductionEnvironment) {
        // eslint-disable-next-line no-console -- non-prod log
        console.log('[Client] Controller changed. Reloading page...');
      }
      window.location.reload();
    });

    registerSW({
      immediate: true, // Register immediately
      onRegisteredSW(swUrl, registration) {
        // check if there is a waiting worker on load (e.g. after a refresh)
        if (registration && registration.waiting) {
          if (!isProductionEnvironment) {
            // eslint-disable-next-line no-console -- non-prod log
            console.log(
              '[Client] Found waiting Service Worker. forcing update...',
            );
          }
          // Force the update
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      },
      onNeedRefresh() {
        if (!isProductionEnvironment) {
          // eslint-disable-next-line no-console -- non-prod log
          console.log('New content available, preparing to update...');
        }
      },
    });
  }
};
